import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { PaginatedArticlesProps } from '@modules/articles/type';
import PaginatedArticlesDesktop from './PaginatedArticles.desktop';
import PaginatedArticlesMobile from './PaginatedArticles.mobile';

const PaginatedArticles: React.FC<PaginatedArticlesProps> = (props) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <>
            {isMobile ? (
                <PaginatedArticlesMobile {...props} />
            ) : (
                <PaginatedArticlesDesktop {...props} />
            )}
        </>
    );
};

export default PaginatedArticles;
